import { CategoryTabIds } from '@shared/constants';

export const LEAVING_SOON_VIEW_HREF = `/event/${CategoryTabIds.LEAVING_SOON}`;
export const NEW_DEALS_VIEW_HREF = `/event/${CategoryTabIds.NEW_DEALS_TODAY}`;

const EIGHT_CAMPAIGNS_CAROUSEL = 8;

// Export constants for backward compatibility if needed
export const CAMPAIGN_COUNT_CONSTANTS = {
    EIGHT_CAMPAIGNS_CAROUSEL,
};
